(() => {
  const sleutel = `vt-hulp:${location.pathname}`;
  const lees = () => { try { return sessionStorage.getItem(sleutel) || ''; } catch (e) { return ''; } };
  const bewaar = (t) => {
    try { if (t.trim()) sessionStorage.setItem(sleutel, t); else sessionStorage.removeItem(sleutel); } catch (e) {  }
  };

  class VtHulp extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.veld = this.querySelector('input[name="vraag"]');
      if (!this.form || !this.veld) return;

      if (!this.veld.value) this.veld.value = lees();
      this.veld.addEventListener('input', () => bewaar(this.veld.value));

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.vraag(this.veld.value, this.form.querySelector('button'));
      });
      this.addEventListener('click', (e) => {
        const knop = e.target.closest('[data-vraag]');
        if (knop) this.vraag(knop.dataset.vraag, knop);
      });

      this.binnenkomen();
    }

    vraag(ruw, bron) {
      const tekst = ruw.trim();
      if (!tekst) { this.veld.focus(); return; }
      this.veld.blur();
      if (window.vtChat && window.vtChat.vraag(tekst, bron)) {
        this.veld.value = '';
        bewaar('');
        return;
      }
      const [pad, anker] = this.dataset.service.split('#');
      location.href = `${pad}?vraag=${encodeURIComponent(tekst)}${anker ? `#${anker}` : ''}`;
    }

    binnenkomen() {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (this.getBoundingClientRect().top < window.innerHeight) return;
      this.classList.add('is-klaar');
      const io = new IntersectionObserver((items) => {
        if (!items.some((i) => i.isIntersecting)) return;
        this.classList.add('is-in');
        io.disconnect();
      }, { rootMargin: '0px 0px -15% 0px' });
      io.observe(this);
    }
  }

  if (!customElements.get('vt-hulp')) customElements.define('vt-hulp', VtHulp);
})();
